import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddAiGenerators from './AddAiGenerators';
import AiGeneratorsList from './AiGeneratorslist';
import EditAiGenerators from './EditAiGenerators';

function AiGenerators() {
  const [generators, setGenerators] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  
  // Initialize userRole from sessionStorage
  const [userRole, setUserRole] = useState(() => {
    return sessionStorage.getItem('userRole') || '';
  });

  useEffect(() => {
    // This is a placeholder for your actual user logic.
    // In a real application, you would get the user role from an API call
    // or an authentication context after a successful login.
    // We will save it to sessionStorage to make it persist in the current tab.
    const user = { role: 'admin' }; // Example user role
    if (user?.role) {
      setUserRole(user.role);
      sessionStorage.setItem('userRole', user.role);
    }
    
    fetchGenerators();
  }, []);

  const fetchGenerators = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/aigenerators`);
      setGenerators(res.data);
    } catch (err) {
      console.error('Fetch failed:', err);
    }
  };

  const handleDelete = async (id) => {
    // We can add a check here to ensure only a user with the correct role can delete.
    if (userRole === 'admin') {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/aigenerators/${id}`);
        fetchGenerators();
      } catch (err) {
        console.error('Delete failed:', err);
      }
    } else {
      console.log('You do not have permission to delete this item.');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4 text-white">AI Generators</h1>

      {/* Show Add button only if not Developer */}
      {userRole !== 'Developer' && (
        <div className="flex justify-end mb-4">
          <button
            onClick={() => setShowAdd(!showAdd)}
            className="bg-green-600 text-white px-4 py-2 rounded"
          >
            {showAdd ? 'Close Form' : 'Add AI Generator'}
          </button>
        </div>
      )}

      {showAdd && (
        <AddAiGenerators closeModal={() => setShowAdd(false)} onAiAdded={fetchGenerators} />
      )}

      {showEdit && (
        <EditAiGenerators id={editId} closeModal={() => setShowEdit(false)} onAiUpdated={fetchGenerators} />
      )}

      <AiGeneratorsList
        generators={generators}
        onDelete={handleDelete}
        onEditClick={(id) => {
          setEditId(id);
          setShowEdit(true);
        }}
        hideActions={userRole === 'Developer'}
      />
    </div>
  );
}

export default AiGenerators;
